import { useHistory } from "react-router-dom";
import { NewsResponse } from "../../../../../../../api/news";
import { timeAgo } from "../../../../../../../utils/common";
import {
  FestivalMainNewsListWrapper,
  FestivalMainNewsListItem,
  FestivalMainNewsListItemText,
} from "./style";
import {
  FestivalSkeletonGrayBox,
  FestivalSkeletonWhiteBox,
} from "../../../../style/skeleton";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
interface RabbitFestivalMainNewsListProps {
  newsList: NewsResponse[];
  loading: boolean;
  search: string;
}
const RabbitFestivalMainNewsList = ({
  newsList,
  loading,
  search,
}: RabbitFestivalMainNewsListProps) => {
  const history = useHistory();
  const { competitionId } = useRabbitFestivalContext();

  return (
    <FestivalMainNewsListWrapper>
      {loading ? (
        Array.from({ length: 4 }, (_, i) => (
          <FestivalMainNewsListItem key={i}>
            <FestivalSkeletonWhiteBox width="79px" height="79px" radius="8px" />
            <FestivalMainNewsListItemText>
              <FestivalSkeletonGrayBox width="220px" height="30px" />
              <FestivalSkeletonGrayBox width="35px" height="20px" />
            </FestivalMainNewsListItemText>
          </FestivalMainNewsListItem>
        ))
      ) : !newsList.length && search ? (
        <div className="no-data">
          '{search}' 관련 뉴스가 존재하지 않습니다.{" "}
        </div>
      ) : (
        newsList.map((item, i) => (
          <FestivalMainNewsListItem
            key={i}
            onClick={() =>
              history.push(
                `news-detail/${item.id}?competition=${competitionId}`
              )
            }
          >
            <div className="image">
              <img src={item.mainImageKey} alt="news" />
            </div>
            <FestivalMainNewsListItemText>
              <div className="news">{item.title}</div>
              <div className="time">{timeAgo(item.createdAt)}</div>
            </FestivalMainNewsListItemText>
          </FestivalMainNewsListItem>
        ))
      )}
    </FestivalMainNewsListWrapper>
  );
};

export default RabbitFestivalMainNewsList;
